<div class="ship-label">
    <a mat-raised-button (click)="downloadLabel($event)" class="download-label">Download Label</a>
    <a class="hide-me" download="label.pdf" [attr.href]="labelPdf | safe:'resourceUrl'" #printButton>Print Label</a>
    <iframe [hidden]="!shouldShowLabel"
            class="print-label"
            #printFile
            width="100%"
            height="600px"
            id="printLabel"
            name="printLabel"></iframe>
    <!--<object id="pdfObject" type="application/pdf" width="100%" height="600px"></object>-->
</div>
